import { render, staticRenderFns } from "./DomainsTemplateCheck.vue?vue&type=template&id=62c9f142&lang=pug&"
import script from "./DomainsTemplateCheck.vue?vue&type=script&lang=js&"
export * from "./DomainsTemplateCheck.vue?vue&type=script&lang=js&"
import style0 from "./DomainsTemplateCheck.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports